import { pullAll } from 'lodash';
import { IDocumentHistoryItem, IHistoryCustomData, IHistoryItem } from '@/framework';
import { IFramework } from '@/framework/instance';
import { traverseTree } from '@/utils/tree-kit';
import { ILayerProps } from '@/version-types';
import { HistoryType as GroupHistoryType, IHistoryPackData } from '../group-layer/type';
import { IHistoryDeleteData, HistoryType as LayerHistoryType } from '../layer/type';

export class RealEditMerge {
    constructor(private framework: IFramework) {}

    merge(item: IHistoryItem<IHistoryCustomData> | IDocumentHistoryItem, isLocal: boolean) {
        if (isLocal) {
            const historyItem = item as IHistoryItem<IHistoryCustomData>;
            const editType = historyItem.data.type;
            let operateLayer;
            if (editType === LayerHistoryType.DELETE) {
                operateLayer = (historyItem.data.data as unknown as IHistoryDeleteData).originLayer;
            } else {
                operateLayer = (historyItem.data.data as unknown as IHistoryPackData).item.layer;
            }
            if (operateLayer) {
                traverseTree(operateLayer, (layer) => {
                    // console.log('ot 写入版本', editType, layer.id, historyItem.serverTime);
                    this.framework.setRealEditTypeVersion(layer.id, editType, historyItem.serverTime);
                });
            }
            return;
        }
        const docItem = item as IDocumentHistoryItem;
        const editType = docItem.type;
        const [originIndex, operateLayer] = docItem.data as [number, ILayerProps];
        const serverTime = docItem.serverTime;
        const isPack = editType === GroupHistoryType.PACK;
        const isUnpack = editType === GroupHistoryType.UNPACK;
        const isDelete = editType === LayerHistoryType.DELETE;
        let isDirtyMessage = false;

        [...(operateLayer.children?.length ? operateLayer.children : [operateLayer])].forEach((layer) => {
            const version = this.framework.getRealEditTypeVersion(layer.id, editType);
            // 如果收到的操作时间小于当前操作时间，不需要处理直接丢弃
            // console.log('ot 版本', layer.id, cloneDeep(version), serverTime, serverTime < version[0]);
            if (serverTime < version[0]) {
                isDirtyMessage = true;
            }
        });

        if (isDirtyMessage) return isDirtyMessage;

        // console.log('ot conflict 1', cloneDeep(this.framework.getRenderIds(0)));
        const brokenIds: Set<string> = new Set();
        if (isPack) {
            console.log('ot pack', operateLayer);
            operateLayer.children?.forEach((child) => {
                const layer = this.framework.getLayer(child.id);
                if (layer?.parentId) {
                    brokenIds.add(layer.parentId);
                }
            });
        }
        if (isUnpack) {
            const latestLayer = this.framework.getLayer(operateLayer.id);
            console.log('ot unpack', latestLayer);
            if (latestLayer.parentId) {
                brokenIds.add(latestLayer.parentId);
            }
        }

        if (isDelete) {
            const latestLayer = this.framework.getWrapLayer(operateLayer.id);
            console.log('ot delete', { operateLayer, latestLayer });
            if (latestLayer?.id) {
                brokenIds.add(latestLayer.id);
            }
        }

        console.log('ot brokenIds', brokenIds);

        if (brokenIds.size) {
            const activeLayer = this.framework.operate.getActiveLayer();
            if (activeLayer) {
                let needDelActiveLayer = false;
                traverseTree(activeLayer, (layer) => {
                    if (brokenIds.has(layer.id)) {
                        needDelActiveLayer = true;
                    }
                });
                if (needDelActiveLayer) {
                    this.framework.operate.delActiveLayer();
                }
            }
            for (const layerId of brokenIds) {
                const brokenGroupLayer = this.framework.getLayer(layerId);
                if (brokenGroupLayer) {
                    const originIds = this.framework.getRenderIds(originIndex);
                    const layerIndex = originIds.indexOf(layerId);
                    const childIds: string[] = (brokenGroupLayer.children || []).map((v) => v.id);
                    this.framework.flatLayersMap.delete(layerId);
                    childIds.forEach((id) => {
                        const childLayer = this.framework.getLayer(id, true);
                        if (childLayer) {
                            childLayer.parentId = undefined;
                            this.framework.stage.addOrUpdate(childLayer, false, originIndex);
                        }
                    });
                    pullAll(originIds, [...childIds, layerId]);
                    originIds.splice(layerIndex, 0, ...childIds);
                    console.log('ot 拆分组', layerId);
                }
            }
        }

        traverseTree(operateLayer, (layer) => {
            const res = this.framework.setRealEditTypeVersion(layer.id, editType, serverTime);
            if (res) layer.__renderRealEditVersion = res;
        });

        // console.log('ot conflict 2', cloneDeep(this.framework.getRenderIds(0)));
        return;
    }
}
